<template>
    <div class="answer-first-name answer-patient-info">

        <v-container v-if="getClickedProduct && getGoToLastName">
            <v-layout row>
                    <v-text-field v-model="firstName"
                                  autofocus
                                  class="chatbot-patient-info"
                                  @keyup="confirmFirstName"
                                  :placeholder="text('api.chatbot.placeholder.patientFirstName')">
                    </v-text-field>

                    <a @click.once="goToLastName" v-if="firstName.length" class="pf-send-arrow">
                        <img src="../../../../assets/send_active.png" alt="avatar">
                    </a>
                    <a  v-else class="pf-send-arrow">
                        <img src="../../../../assets/send_disabled.png" alt="avatar">
                    </a>


            </v-layout>

        </v-container>

    </div>
</template>

<!-- ################################################################## -->

<script>
    import { mapGetters } from 'vuex';

    export default {
        name: 'AnswerFirstName',
        data(){
            return {
                firstName: ''
            }
        },
        computed: {
            ...mapGetters({
                getClickedProduct: 'ChatBotStore/getClickedProduct',
                getPatientFirstName: 'ChatBotStore/getPatientFirstName',
                getGoToLastName: 'ChatBotStore/getGoToLastName'
            })
         },

        watch: {
            getGoToLastName(newVal, oldVal) {

                if (newVal === true) {
                    this.$nextTick(function () {
                        this.$emit('onAnswerListUpdated');
                    });
                }

            }
        },

        methods: {
            goToLastName() {
                this.$store.commit('ChatBotStore/setPatientFirstName', this.firstName);
                this.$store.dispatch("ChatBotStore/selectFirstName", {
                    fieldName: "FIRST_NAME",
                    fieldValue: this.firstName
                });
            },
            confirmFirstName(e) {
                if(this.firstName.length) {
                    if (e.keyCode === 13) {
                        this.goToLastName();
                    }
                }
            }

        }
    }
</script>



// WEBPACK FOOTER //
// src/pathfinder/components/chatbot/answer-list/AnswerFirstName.vue